/**************************************************************************
 * Created on Mon Nov 04 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import React, { useMemo, useState } from "react"
import { ModalContext } from "./ModalContext";
import { AlertConfirmationModal } from "../AlertConfirmationModal";


interface IDSSProvider
{
    children: React.ReactNode;

}

export type ModalType = "ALERT" | "CONFIRM";

/***
 * Modal Provider need to wrapped the current object to active the modal window 
 * Prefferbly use it at Router level
 */
export const ModalProvider = ({ children }: IDSSProvider) =>
{

    const [ isOpen, setIsOpen ] = useState<boolean>(false);
    const [ cancelButtonText, setCancelButtonText ] = useState('');
    const [ doneButtonText, setDoneButtonText ] = useState('');
    const [ modalType, setModalType ] = useState<ModalType>('CONFIRM');
    const [ title, setTitle ] = useState('');
    const [ dialogmsg, setDialogmsg ] = useState('');
    const [ onDone, setOnDone ] = useState<(() => void) | undefined>(undefined);
    const [ onClose, setOnClose ] = useState<(() => void) | undefined>(undefined);


    /**
     * 
     * @param title Modal window title
     * @param dialogmsg Modal window dialog Message to display 
     * @param cancelButtonText Text/Label of the cancle or close button 
     * @param doneButtonText  Text/Label of the confirm/yes button 
     * @param onDoneCallback on Click done button event handler
     * @param onCloseCallback on click of cancel button handler
     * Example of uses @example
       openConfirmModal("Heading", "Body", "Close", "Done",()=>{//on DONE},()=>{//on CLOSE})
     */
    const openConfirmModal = (title: string, dialogmsg: string, cancelButtonText: string, doneButtonText?: string, onDoneCallback?: () => void, onCloseCallback?: () => void, modalTpe?: ModalType) =>
    {
        setIsOpen(true);
        setTitle(title);
        setDialogmsg(dialogmsg);
        setCancelButtonText(cancelButtonText);
        setDoneButtonText(doneButtonText ?? "");
        setModalType("CONFIRM")
        setOnDone(() => onDoneCallback);
        setOnClose(() => onCloseCallback);
    }



    /**
    * 
    * @param title Modal window title
    * @param dialogmsg Modal window dialog Message to display 
    * @param cancelButtonText Text/Label of the cancle or close button  
    * @param onCloseCallback on click of cancel button handler
    * Example of uses @example
      openAlertmModal("Heading", "Body", "Close",  ()=>{//on CLOSE})
    */

    const openAlertmModal = (title: string, dialogmsg: string, cancelButtonText: string, onCloseCallback?: () => void) =>
    {
        setIsOpen(true);
        setTitle(title);
        setDialogmsg(dialogmsg);
        setCancelButtonText(cancelButtonText);
        setDoneButtonText(doneButtonText ?? "");
        setModalType("ALERT");
        setOnClose(() => onCloseCallback);
    }


    /**
     * Close the open modal window
     */
    const closeConfirmModal = () =>
    {
        setIsOpen(false);

    }
    const opt = useMemo(() => (
        {

            isOpen,
            openConfirmModal,
            openAlertmModal,
            closeConfirmModal,
            title,
            dialogmsg,
            cancelButtonText,
            doneButtonText,
            onDone,
            onClose,
            modalType

        }), [
        openConfirmModal,
        openAlertmModal,
        closeConfirmModal,
        title,
        dialogmsg,
        cancelButtonText,
        doneButtonText,
        onDone,
        onClose,
        modalType

    ])
    return (
        <ModalContext.Provider
            value={ opt }>
            { children }
            <AlertConfirmationModal />
        </ModalContext.Provider>
    )
}